import { round } from '@/helpers/ost';
import { ICartItem } from '@/types/cart';
import { ISearchObject } from '@/types/search';

/**
 * Возвращает позицию корзины по идентификатору препарата.
 * Если позиция отсутствует, возвращает пустую позицию по умолчанию.
 * @param prepId Идентификатор препарата.
 * @param cart Корзина пользователя.
 */
export function getCartItem(prepId: number, cart: ICartItem[]): ICartItem {
    return cart.find(item => item.prep_id === prepId) || {
        prep_id: 0,
        rcfi_name: '',
        quantity: 0,
        min_price: 0,
        proizv_name: '',
        need_recipe: 0
    };
}

/**
 * Возвращает суммарную стоимость корзины.
 * @param cart Корзина пользователя.
 */
export function getCartSum(cart: ICartItem[]): number {
    const sum = cart ? round(cart.reduce((a, b) => a += b.min_price * b.quantity, 0)) : 0;
    return sum;
}

/**
 * Проверяет, что количество товаров в корзине не превышает доступное количество в аптеке.
 * @param object Аптека с препаратами.
 * @param cart Корзина пользователя.
 */
export function checkCartQuanties(object: ISearchObject, cart: ICartItem[]): boolean {
    let isError = false;
    cart.forEach(item => {
        const prepInObject = object.preps.find(prep => prep.group_id === item.prep_id);
        if (prepInObject && prepInObject.quantity < item.quantity) isError = true;
    });
    return !isError;
}

/**
 * Возвращает true, если в корзине есть хотя бы один рецептурный препарат.
 * @param cart Корзина пользователя.
 */
export function findRecipeInCart(cart: ICartItem[]): boolean {
    return cart.some(item => item.need_recipe === 1);
}